/*
 * $Id:: TranslationProvider.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

let _literals = {};
let _locale = 'pt';

/**
 *
 * @param {string} text The string with the parameters in {}
 * @param {object} params Replacement can be string or JSX
 */
const replaceParams = (text, params) => {
    const paramRegExp = new RegExp(/{[a-zA-Z]+}/g);
    const matches = text.match(paramRegExp);
    let splits = text.split(paramRegExp);

    for (let i = 0; i < splits.length - 1; i++) {
        splits[i] = (
            <React.Fragment key={i}>
                {splits[i]}
                {params[matches[i].slice(1, -1)]}
            </React.Fragment>
        );
    }

    return splits;
};

const Translation = (key, params, _options) => {
    const literals = _literals;

    // TODO: Refine this when getting translations from API.
    let translated = '';
    if (literals && literals[key]) {
        if (params) {
            translated = replaceParams(literals[key], params);
        } else {
            translated = literals[key];
        }
    } else if (typeof key === 'string') {
        translated = key.split('.').join(' ');
        translated = `${translated[0].toUpperCase() + translated.slice(1)} *`;
    }

    return translated;
};

export const setLiterals = (literals) => {
    _literals = { ...literals };
};

export const setLocale = (languageCode) => {
    _locale = languageCode;
};

export const getLocale = () => {
    return _locale;
};

export const t = (key, params, options) => Translation(key, params, options);
